import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, mediaQuery, border } = baseVariables;

export const StyledReslinkEventDetails = styled.div`
  .loader {
    position: relative;
    left: 50%;
    margin: ${toRem(24)};
    width: ${toRem(24)};
    height: ${toRem(24)};
  }

  .event-details {
    padding: ${toRem(40)} ${toRem(16)} ${toRem(8)};
    border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
    border-radius: ${toRem(12)};
    background-color: ${color.base20};
    box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

    @media ${mediaQuery.md} {
      padding: ${toRem(40)} ${toRem(40)} ${toRem(8)};
    }
  }

  .back-cta {
    color: ${color.alert40};
  }

  .back-to-hub-modal {
    .footer {
      display: flex;
      flex-direction: column;
      margin-top: ${toRem(25)};
      button {
        width: 100%;
        &:first-child {
          margin-bottom: ${toRem(15)};
        }
      }

      @media ${mediaQuery.md} {
        flex-direction: row;
        justify-content: flex-end;
        button {
          width: auto;
          &:first-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .tnc-option {
    max-width: ${toRem(300)};
  }

  .tnc-link {
    color: ${color.alert40};
    margin-left: ${toRem(3)};
  }
`;
